'use client';

import { useTranslation } from 'next-i18next';

export const CardAgencyBadge = () => {
  const { t } = useTranslation('common');
  return (
    <div className="absolute -top-2 left-2 flex rounded-full bg-[#BA45A4] px-2 py-0.5 text-pico text-white">
      {t('global.label.best')}
    </div>
  );
};
